const countries = require('./resources/countries-min');
const industries = require('./resources/industries');

const createTopicHash = (topicName) => {
	if(!topicName){
		throw new Error('Cannot create hash from empty name!');
	}
	return topicName.toLowerCase().replace(/\s+/g, '').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, '');
};

const ageGroups = [
  { name: '0-17', from: 0, to: 17 },
  { name: '18-25', from: 18, to: 25 },
  { name: '26-35', from: 26, to: 35 },
  { name: '36-55', from: 36, to: 55 },
  { name: '56+', from: 56, to: 199 }
];
const getAgeGroupName = (age) => {
  let ageGroupName = null;
  if (Number.isInteger(age)) {
		for (let i = 0; i < ageGroups.length; i++) {
			const ageGroup = ageGroups[i];
			if (Math.max(ageGroup.from, Math.min(age, ageGroup.to)) === age) {
				ageGroupName = ageGroup.name;
				break;
			}
		}
  }
  return ageGroupName;
};

const getCountryByCode= (countryCode) => {
  const country = countries.find(c => c.code === countryCode);
  return country;
};

const getIndustries = () => {
	return industries;
};

module.exports = { createTopicHash, getAgeGroupName, getCountryByCode, getIndustries };